export default __webpack_public_path__ + "static/media/default.6e862e17.svg";